import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName"
import { ISymbolData, ISymbolDim, ISymbolConfig } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/IReelSymbolData";
import { SymbolData } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";
import { LoaderEvent } from "@nolimitcity/slot-game/bin/core/resource/event/LoaderEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { ResourcesGroupName } from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";

/**
 * Created by SH on 28/7/2019.
 */

export enum ReelSymbolSize {
    ONE = 1, TWO = 2, THREE = 3,
    FOUR = 4, FIVE = 5, SIX = 6,
    SEVEN = 7, EIGHT = 8, TEN = 10,
}

export interface SymValue{
    [name:string]:SymValueData;
 }
 export interface SymValueData {
    [name:string]:SymValueDataData;
 }
 export interface SymValueDataData{
    [name:string]:number;
 }

export class SanSymbolData extends SymbolData {

    protected SymbolsPreDefined:ISymbolConfig[] = [
        {
            NAME: "S",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "W",
            DIM: undefined,
            MULTISIZE: true,
            MULTI_STATES:{
                "2":{
                    win:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W2_Win",
                    },
                    idle:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W2_Win",
                    },
                },
                "4":{
                    win:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W4_Win",
                    },
                    idle:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W4_Win",
                    },
                    police:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W_J/4/JW_Policeman",
                    },
                },
            },
        },
        // ----------
        {
            NAME: "L1",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "L2",
            DIM: undefined,
            MULTI_STATES:{
                "4":{
                    normal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "L2/4/L2_normal",
                    }
                },
            },
            MULTISIZE: true,
        },
        {
            NAME: "L3",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "L4",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "L5",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "M1",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "M2",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "M3",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "M4",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "M5",
            DIM: undefined,
            MULTISIZE: true,
        },
        {
            NAME: "M",
            DIM: undefined,
            MULTISIZE: true,
            MULTI_STATES:{
                "7":{
                    bottom:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "M/7/M_normal_bottom",
                    }
                },
            }
        },
        {
            NAME: "X",
            DIM: undefined,
            MULTISIZE: false,
            NORMAL_STATES:{
                spin:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "X/X_spin",
                },
                normal:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "X/normal",
                },
                normal2:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "X/normal2",
                },
                normal3:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "X/normal3",
                },
                normal4:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "X/normal4",
                }
            }
        },
        {
            NAME: "Z",
            DIM: undefined,
            MULTISIZE: false,
            NORMAL_STATES:{
                spin:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "Z/Z_spin",
                },
                normal:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "Mystery_Explode/M_Explode_00000",
                },
            }
        },
        {
            NAME: "W_J",
            DIM: undefined,
            MULTISIZE: true,
            MULTI_STATES:{
                "2":{
                    normal:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W_J/2/JW",
                    },
                    spin:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W_J/2/JW_BG",
                    },
                    empty:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W_J/2/JW_Empty",
                    }
                },
                "4":{
                    normal:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W_J/4/JW"
                    },
                    spin:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W_J/4/JW_BG",
                    },
                    inactive:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "Jumping_Wild/JW_4_Badge_Dead",
                    },
                    attention:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "JW_Reveal",
                    },
                    police:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W_J/4/JW_Policeman",
                    },
                    empty:{
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1,1),
                        },
                        TEXTURE_PATH: "W_J/4/JW_Empty",
                    }
                },
            }
        },
        {
            NAME: "W_S",
            DIM: undefined,
            MULTISIZE: false,
            NORMAL_STATES:{
                idle:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "W_Split_Win",
                },
                normal:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "W_S/WS_normal",
                },
                spin:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "W_S/WS_spin",
                },
                landing:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "W_Split_Land",
                },
                win:{
                    DIM: {
                        WIDTH: 110,
                        HEIGHT: 180,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1,1),
                    },
                    TEXTURE_PATH: "W_Split_Win",
                }
            }
        },
    ];

    private static symbolValues:SymValue;
    private static initiated:boolean = false;

    protected SpecialSymbols:string[] = [ ReelSymbolName.SCATTER,ReelSymbolName.WILD, ReelSymbolName.MYSTERY,"W_J","X","W_S","Z"];

    private resLoaded:boolean = false;

    private get basicDataCreated():boolean{
        return SanSymbolData.Configs.length > 0;
    }

    public static get DEFAULT_SYMBOL():ISymbolData{
        return this._defaultConfiguration;
    }

    protected addEventListeners():void{
        super.addEventListeners();
        EventHandler.addFirstEventListener(this, LoaderEvent.RESOURCES_LOADED, (event:LoaderEvent) => this.defineInit(event));
        
    }

    protected InitDataReceived(data:any):void{
        super.InitDataReceived(data);
        SanSymbolData.symbolValues = data.symbolValues;
        this.tryCreateData();
    }

    protected defineInit(res:LoaderEvent):void{
        if(res.key != ResourcesGroupName.MAIN) return;
        this.resLoaded = true;
        this.tryCreateData();
    }

    protected tryCreateData():void{
        if(SanSymbolData.initiated || !this.resLoaded || !this.basicDataCreated) return;

        SanSymbolData.initiated = true;
        SanSymbolData.InitSymbolData();
    }

    public static getTextures(sym:string,state:string,type?:string, fallbackType:string = "4"):PIXI.Texture[]{


        const textures:PIXI.Texture[] = super.getTextures(sym,state,type)!;
        if(!textures)
            return super.getTextures(sym,state,fallbackType)!;
        else
            return textures;
    }

    public static isNormalSymbol(name:string):boolean{
        return name.length > 1 && name[0] == "L" || name[0] == "M";
    }

    public static SymbolWinValues(symName:string):SymValueData{
        return SanSymbolData.symbolValues[symName];
    }

    public static getAllConfigs():ISymbolConfig[]{
        return this.Configs;
    }
}